import { useTranslation } from "react-i18next";
import React from 'react';
import { Container } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import AdminLayout from 'Components/Admin/AdminLayout';
import SingleUser from 'Components/Admin/SingleUser';
export default function Main(props) {
  const {
    t
  } = useTranslation();
  return <AdminLayout>
      <Helmet>
        <title>{t("Users - HeresMyInfo.com")}</title>
      </Helmet>
      <Container>
        <h4 className="mb-4" style={{
        fontSize: '1.5rem',
        textTransform: 'none',
        letterSpacing: 'normal',
        fontWeight: 600,
        color: 'white'
      }}>{t("User Connections Status")}</h4>
        <SingleUser userId={props.match.params.userId} />
      </Container>
    </AdminLayout>;
}